import { changeStatusFile } from 'common/api/financierAllianceInstaller';
import { REJECTED_STATUS } from 'common/constants';
import alerts from 'common/modules/alerts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import {
    REJECT_FILE,
    REJECT_FILE_FAILURE,
    REJECT_FILE_SUCCESS,
} from '../actionTypes';
import { installerProfileActions } from '../reducer';

export default (file, callback) => (dispatch) => {
    const newValues = { status: REJECTED_STATUS };

    dispatch(installerProfileActions[REJECT_FILE]());

    changeStatusFile(file.id, newValues)
        .then(() => {
            dispatch(installerProfileActions[REJECT_FILE_SUCCESS]());
            if (callback) callback();
            dispatch(alerts.actions.close());
        })
        .catch((error) => {
            dispatch(
                installerProfileActions[REJECT_FILE_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
